var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.svg#radio-checked--oHdTV';
                    var viewUrl = 'sprites.svg#view-radio-checked--oHdTV';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 19 18',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };